import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { LeadSourceReport } from './LeadSourceReport';
import { CampaignReport } from './CampaignReport';
import { CampaignFlowReport } from './CampaignFlowReport';
import { BulkSpendGrid } from '@/components/campaigns/BulkSpendGrid';
import { useTimezoneUtils } from '@/hooks/useTimezoneUtils';

interface LeadSourceCampaignTabsProps {
  startDate: Date;
  endDate: Date;
  timezone?: string;
  compareEnabled?: boolean;
}

export const LeadSourceCampaignTabs = ({ startDate, endDate, timezone: propTimezone, compareEnabled = false }: LeadSourceCampaignTabsProps) => {
  const { timezone: contextTimezone } = useTimezoneUtils();
  const timezone = propTimezone || contextTimezone;
  
  return (
    <Tabs defaultValue="flow" className="space-y-6">
      <TabsList>
        <TabsTrigger value="flow">Campaign flow</TabsTrigger>
        <TabsTrigger value="sources">Lead Sources</TabsTrigger>
        <TabsTrigger value="campaigns">Campaigns</TabsTrigger>
        <TabsTrigger value="daily-spend">Daily Spend</TabsTrigger>
      </TabsList>

      <TabsContent value="flow">
        <CampaignFlowReport startDate={startDate} endDate={endDate} timezone={timezone} />
      </TabsContent>

      <TabsContent value="sources">
        <LeadSourceReport startDate={startDate} endDate={endDate} timezone={timezone} compareEnabled={compareEnabled} />
      </TabsContent>

      <TabsContent value="campaigns">
        <CampaignReport startDate={startDate} endDate={endDate} timezone={timezone} compareEnabled={compareEnabled} />
      </TabsContent>

      <TabsContent value="daily-spend">
        <BulkSpendGrid />
      </TabsContent>
    </Tabs>
  );
};
